export default "__VITE_ASSET__3dc5678a__"